import React, {Component} from 'react';
import {Typography} from "@material-ui/core";
import {Color} from "../utis/Styles";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";

class Calling extends Component{
	static defaultProps = {
		isMakeCall: true,
		peerUserName: ''
	}

	renderGetCallToolBar() {
		const { classes } = this.props
		return (
			<div className={classes.toolbar}>
				<Button  onClick={() => {
					this.props.refuseCall && this.props.refuseCall()
				}}  className={classes.leftButton}>
					<img alt={'reject'} style={{width: 50, height: 50}} src={require('../assets/images/reject.png')}/>
				</Button>

				<Button onClick={() => {
					this.props.acceptCall && this.props.acceptCall()
				}}   className={classes.rightButton}>
					<img alt={'accept'} style={{width: 50, height: 50}} src={require('../assets/images/accept.png')}/>
				</Button>
			</div>
		)
	}

	renderMakeCallToolBar() {
		const { classes } = this.props
		return (
			<div className={classes.centerToolBar}>
				<Button onClick={() => {
					this.props.cancelCall && this.props.cancelCall()
				}}  className={classes.centerButton}>
					<img alt={'reject'} style={{width: 50, height: 50}} src={require('../assets/images/reject.png')}/>
				</Button>
			</div>
		)
	}

	render() {
		const { classes } = this.props
		let title = this.props.isMakeCall ? 'Calling to ' : 'Receive calling from'
		return(
			<div className={classes.root}>
				{/*<img src="#" alt="Smiley face" className={classes.peerIcon} />*/}

				<Typography variant={'body2'} className={classes.title}>
					{title}
				</Typography>
				<Typography variant={'body2'} className={classes.title}>
					{this.props.peerUserName}
				</Typography>

				{this.props.isMakeCall ? this.renderMakeCallToolBar(classes) : this.renderGetCallToolBar(classes)}
			</div>
		)
	}
}

const styles = (theme) => ({
	root: {
		width: '100%',
		height: '100%',
		backgroundColor: Color.black,
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center'
	},
	peerIcon: {
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
	},
	toolbar: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'absolute',
		bottom: 20,
		left: 118
	},
	title: {
		color: Color.white,
		fontSize: 24,
		textAlign: 'center',
	},
	leftButton: {
		marginRight: 135,
		width: 50,
		height: 50,
	},
	rightButton: {
		width: 50,
		height: 50,
	},
	centerToolBar: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'absolute',
		bottom: 20,
		width: '100%',
		left: 0,
	},
	centerButton: {
	},
})

export default withStyles(styles)(Calling)
